import { type FC, useEffect } from 'react'
import { Flex, Text } from "~/foundation/Chakra"
import { cubicBezier, motion, useAnimationControls } from 'framer-motion';

const MotionText = motion(Text);

type CounterCharProps = {
	place: number;
	value: string;
	fontSize: string;
	animate: boolean;
	duration: number;
}

export const CounterChar: FC<CounterCharProps> = ({ place, value, fontSize, animate, duration }) => {
	const controls = useAnimationControls();

	useEffect(() => {
		if (animate) {
			controls.start({
				opacity: 1,
				transition: { duration, ease: cubicBezier(.35, 1, .45, 1) }
			});
		}
	}, [animate, controls]);
	return (
		<Flex
			right={`${0.5 * (place - 1) + 0.25}em`}
			position="absolute"
			height="0.5em"
			alignItems="center"
			justifyContent="center"
			width="0.5em"
		>
			<MotionText
				animate={controls}
				opacity={0}
				fontFamily="heading"
				fontSize={fontSize}
			>
				{value}
			</MotionText>
		</Flex>
	)
}